import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: null,
};

function ParticipantLayout({ children }) {
  return <div className="Background-Legacy Background--dark-gray">{children}</div>;
}

ParticipantLayout.propTypes = propTypes;
ParticipantLayout.defaultProps = defaultProps;

export default ParticipantLayout;
